import { LogRecordExporter, ReadableLogRecord, } from '@opentelemetry/sdk-logs';
import { ExportResult, ExportResultCode } from '@opentelemetry/core';
import { Attributes } from '@opentelemetry/api';

import { idGenerator } from '../utils/generateUUID';
import { hrTimeToNanosNumber } from '../utils/hrTimeToNanoNumber';
import { AppEnv, defaultResourceAttr, pointKillTag } from '../const';
import { convertAttributesToString } from '../utils/convertAllAttrIntoString';
import { processSnipConfig } from '../utils/getSnippingConfig';

export class CustomExporter implements LogRecordExporter {
  private logPrefix: string = "force-log-prefix"
  private logSuffix: string = "force-log-suffix"
  constructor() { }

  export(logs: ReadableLogRecord[], resultCallback: (result: ExportResult) => void) {
    // 1. 过滤掉被点杀的日志
    const filteredLogs = logs.filter(log => {
      const pkTag = log.attributes?.[pointKillTag] as string;
      if (pkTag) {
        try {
          const snipingConfig = processSnipConfig(pkTag);
          if (snipingConfig?.logs?.modules?.includes("*")) {
            return false;
          }
          const module = log.attributes?.module as string;
          if (module && snipingConfig?.logs?.modules?.includes(module)) {
            return false;
          }
        } catch (e) {
          console.error(`Failed to parse ${pointKillTag} in log exporter:`, e);
        }
      }
      return true;
    });

    if (filteredLogs.length === 0) {
      resultCallback({ code: ExportResultCode.SUCCESS });
      return;
    }

    const isDev = process.env.NODE_ENV === "development";
    const defaultAttributes: Attributes = {
      uuid: idGenerator.generateTraceId(),
      app_env: isDev ? AppEnv.Dev : AppEnv.Prod,
    };

    // 模拟 OTLP 的结构化过程
    const otlpLikeStructure = {
      resource: {
        attributes: {
          ...defaultResourceAttr
        }
      },
      logRecords: filteredLogs.map(log => ({
        timeUnixNano: hrTimeToNanosNumber(log.hrTime),
        observedTimeUnixNano: hrTimeToNanosNumber(log.hrTimeObserved),
        severityNumber: log.severityNumber,
        severityText: log.severityText,
        body: log.body,
        attributes: convertAttributesToString({
          ...defaultAttributes,
          ...(log.attributes ?? {}),
        }),
        traceID: log.spanContext?.traceId,
        spanID: log.spanContext?.spanId
      }))
    }
    console.log(this.logPrefix + JSON.stringify(otlpLikeStructure) + this.logSuffix);

    resultCallback({ code: ExportResultCode.SUCCESS });
  }

  async shutdown() { }
}